import { ref, computed, watch, onMounted } from "vue"
import { lottery } from "@/api/api"
import { showToast } from "vant"
import { useRouter } from "vue-router"
import bus from "@/lib/bus"
export default {
  props: ["backgroundImage", "lotteryList", "gameId", "choiceAread"],
  setup(props, context) {
    const backgroundStyle = computed(() => ({
      backgroundImage: `url(${props.backgroundImage})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
    }))
    watch(
      () => props.lotteryList,
      () => {
        // 在这里处理对象变化的逻辑
        initRoll()
      },
      { deep: true }
    )
    const time = ref() //倒计时
    onMounted(() => {
      initRoll()
    })
    // 转盘转速
    const defaultConfig = ref({
      speed: 20,
      accelerationTime: 500,
      decelerationTime: 1500,
      gutter: 3,
      // offsetDegree: 360 / props.lotteryList.extend.reward_list.length / 2,
    })
    // 转盘背景色
    const blocks = ref([
      {
        background: "#706a69",
        // padding: "10px",
        // imgs: [
        //   {
        //     src: "https://download4.qcplay.com/qcgame-api/fJWp4vKVD55wdXCWEmk6d68W7A6UvJ4ulDIkxeum.png",
        //     width: "320px",
        //     height: "320px",
        //   },
        // ],
      },
    ])
    // 转盘奖励
    const prizes = ref([])
    const buttons = ref([
      {
        radius: "25%",
        pointer: false,
        imgs: [
          {
            src: "https://download4.qcplay.com/qcgame-api/bjPL1326SfKkPk51q3rlj8bOa6RODYJ4kAQgQvRc.png",
            width: "70px",
            height: "85px",
            top: "-55px",
          },
        ],
        // fonts: [
        //   { text: `剩余${props.lotteryList.remain_num}次`, top: "-10px" },
        // ],
      },
    ])

    const myLucky = ref(null) //转盘对象
    const lotteryDetail = ref({}) //抽奖结果详情
    const rollIndex = ref(0) //抽奖序列号
    const isLottering = ref(false) //抽奖状态关闭抽奖点击按钮

    // 开始抽奖
    const startCallback = () => {
      if (!localStorage.getItem("mobile")) return bus.$emit("click") //未登录调取登录接口
      if (isLottering.value) return
      if (!props.choiceAread) return showToast("暂无游戏角色，无法参与该活动")
      isLottering.value = true
      lottery({
        id: props.lotteryList.id,
        game_id: props.gameId,
        server_id: props.choiceAread.dist_id,
        server_name: props.choiceAread.dist_name,
        role_id: props.choiceAread.role_id,
        role_name: props.choiceAread.nickname,
        os: props.choiceAread.os,
      }).then((res) => {
        console.log(res)
        if (res.code == 401) {
          setTimeout(() => {
            isLottering.value = false
          }, 3500)
          return
        }
        if (res.code != 200) {
          setTimeout(() => {
            isLottering.value = false
          }, 3500)
          // js正则删除换行符
          const regex = /\\n/g
          const result = res.message.replace(regex, "\n")
          showToast(result)
          return
        }
        lotteryDetail.value = res.data
        props.lotteryList.extend.reward_list.forEach((item, index) => {
          if (item.id == lotteryDetail.value.reward.id) {
            rollIndex.value = index
          }
        })
        myLucky.value.play()
        setTimeout(() => {
          myLucky.value.stop(rollIndex.value)
        }, 1000)
      })
    }

    // 转盘结束抽奖后执行函数
    const endCallback = (prize) => {
      console.log(prize)
      showLotteryResult.value = true
      isLottering.value = false
      // 成功抽奖后需要执行的函数
      context.emit("lotteryRefresh")
    }
    // 初始化奖励
    const initRoll = () => {
      prizes.value = []
      props.lotteryList.extend.reward_list.forEach((item) => {
        prizes.value.push({
          fonts: [
            {
              text: item.name,
              top:
                props.lotteryList.extend.reward_list.length == 9 ? "7%" : "10%",
              fontSize: "10px",
              fontColor: item.font_color,
            },
          ],
          background:
            props.lotteryList.type == 2 && item.is_drawn == 2
              ? "#cccccc"
              : item.color,
          imgs: [
            {
              src:
                item.is_drawn == 2 ? item.image_sold_out_url : item.image_url,
              width:
                props.lotteryList.extend.reward_list.length == 9
                  ? "53px"
                  : "30px",
              height:
                props.lotteryList.extend.reward_list.length == 9
                  ? "53px"
                  : "30px",
              top:
                props.lotteryList.extend.reward_list.length == 9
                  ? "16px"
                  : "40px",
            },
          ],
        })
      })
      const endTime = new Date(props.lotteryList.ended_at).getTime()
      const now = new Date().getTime()
      time.value = endTime - now
      myLucky.value.init()
    }
    const showLotteryResult = ref(false) //抽奖结果弹窗
    // 获得的抽奖奖品为实物
    const realityPrize = () => {
      context.emit("realityPrize", props.lotteryList.id)
    }
    // 红包壳展示
    const getRewardCode = () => {
      showLotteryResult.value = false
      context.emit("redPagePrize", lotteryDetail.value.serial_number)
      // context.emit("redPagePrize", 66666)
    }
    // 前往兑换记录页面
    const route = useRouter()
    const goExchangeRecord = () => {
      if (!localStorage.getItem("mobile")) return bus.$emit("click") //未登录调取登录接口
      route.push({
        path: `./exchangerecord`,
        query: {
          id: props.lotteryList.type == 2 ? 1 : 0,
        },
      })
    }
    const rulerPopup = ref(false) //奖池规则弹窗
    const rulerShow = () => {
      rulerPopup.value = true
    }
    return {
      time,
      rulerShow,
      rulerPopup,
      isLottering,
      goExchangeRecord,
      getRewardCode,
      realityPrize,
      showLotteryResult,
      initRoll,
      defaultConfig,
      backgroundStyle,
      blocks,
      prizes,
      buttons,
      myLucky,
      startCallback,
      endCallback,
      lotteryDetail,
    }
  },
}
